/**
 * Zeigt ein Overlay mit den verfügbaren Pässe an und ermöglicht die Auswahl eines anwendbaren Passes.
 *
 * @param {Array} applicablePassesForEvent - Liste der globalen Pässe, die für das Event anwendbar sind.
 * @param {Array} userEventPasses - Liste der Pässe, die für das Event verfügbar sind (inkl. der verbrauchten).
 * @param {Function} onPassSelect - Callback-Funktion, wenn ein anwendbarer Pass ausgewählt wird.
 * @param {Function} onNoPassSelect - Callback-Funktion, wenn der Benutzer ohne Pass fortfahren möchte.
 */
export async function showPassSelectionOverlay(applicablePassesForEvent, userEventPasses, onPassSelect, onNoPassSelect) {

  // Container für das Overlay
  const overlayContainer = document.createElement('div');
  overlayContainer.classList.add('pass-selection-overlay');

  // Inhalt des Overlays in pass-selection-content div
  const contentContainer = document.createElement('div');
  contentContainer.classList.add('pass-selection-content');

  // Schließen-Button hinzufügen
  const closeButton = document.createElement('span');
  closeButton.textContent = '×';
  closeButton.classList.add('close-overlay-button');
  closeButton.style.cursor = 'pointer';
  closeButton.addEventListener('click', () => {
    document.body.removeChild(overlayContainer);
  });

  // Überschrift hinzufügen
  const heading = document.createElement('h2');
  heading.textContent = 'Available passes';
  contentContainer.appendChild(heading);

  // Füge den Schließen-Button zum Inhalt hinzu
  contentContainer.appendChild(closeButton);

  // Verfügbare Pässe für das Event (aus globalen und event-spezifischen Pässen)
  userEventPasses.forEach(pass => {
    const passContainer = document.createElement('div');
    passContainer.classList.add('pass-item');

    // Pass Name anzeigen
    const passName = document.createElement('h3');
    passName.textContent = pass.name;
    passContainer.appendChild(passName);

    // Überprüfen, ob der Pass anwendbar ist (global anwendbare Pässe)
    const isPassApplicable = applicablePassesForEvent.some(applicablePass => applicablePass.id === pass.id);

    // Überprüfen, ob der Pass Fehler enthält (event-spezifische Fehler)
    if (!isPassApplicable || !pass.is_applicable) {
      // Wenn der Pass nicht anwendbar ist, Fehlertext anzeigen
      const errorMessage = document.createElement('p');
      errorMessage.textContent = pass.errors.join(', ');  // Fehler aus userEventPasses anzeigen
      errorMessage.classList.add('error-message');
      passContainer.appendChild(errorMessage);

      // Pass optisch deaktivieren
      passContainer.classList.add('disabled');
    } else {
      // Pass order message
      const orderMessage = document.createElement('p');
      orderMessage.textContent = formatOrderMessage(pass); // Nachricht formatieren
      orderMessage.classList.add('order-message');
      passContainer.appendChild(orderMessage);
      // Wenn der Pass anwendbar ist, klickbar machen
      passContainer.classList.add('clickable');
      passContainer.addEventListener('click', () => {
        onPassSelect(pass);  // Pass-Callback aufrufen
        document.body.removeChild(overlayContainer); // Schließe Overlay nach Auswahl
      });
    }

    // Pass-Container zum Content hinzufügen
    contentContainer.appendChild(passContainer);
  });

  // Option "Ohne Pass fortfahren"
  const noPassButton = document.createElement('button');
  noPassButton.textContent = 'Buy additional tickets';
  noPassButton.classList.add('no-pass-button', 'button', 'red');
  noPassButton.addEventListener('click', () => {
    onNoPassSelect();  // Ohne Pass fortfahren Callback
    document.body.removeChild(overlayContainer);  // Schließe Overlay nach Auswahl
  });

  contentContainer.appendChild(noPassButton);

  // Füge den Inhalt zum Overlay hinzu
  overlayContainer.appendChild(contentContainer);

  // Füge das Overlay zum DOM hinzu
  document.body.appendChild(overlayContainer);

  // Klick außerhalb des Modals schließt das Overlay
  overlayContainer.addEventListener('click', (event) => {
    if (event.target === overlayContainer) {
      document.body.removeChild(overlayContainer);
    }
  });
}

/**
 * Formatiert die Order Message basierend auf den Platzhaltern und den Pass-Informationen.
 *
 * @param {Object} eventPass - Das Event-Pass-Objekt mit Informationen zum Pass.
 * @returns {string} - Die formatierte Order Message.
 */
function formatOrderMessage(eventPass) {
  const quantity = '1+'
  const tickets = 'tickets';
  const passName = eventPass.name || 'Pass';
  const price = '0,00'; // Preis: Angenommen, es ist 100% Rabatt

  // Ersetze die Platzhalter in der Nachricht
  let message = eventPass?.pass_bucket?.order_message || '';
  message = message.replace('{{quantity}}', quantity);
  message = message.replace('{{tickets}}', tickets);
  message = message.replace('{{pass}}', passName);
  message = message.replace('{{price}}', price);

  return message;
}
